module.exports = __webpack_public_path__ + "assets/img/icon9.5a520fd9.png";